import React from 'react';

import classes from './Input.module.scss';

import { FormattedMessage } from 'react-intl';

const input = (props) => {
    let inputElement = null;
    const inputClasses = [classes.InputElement, 'InputElement'];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }

    switch (props.elementType) {
        case ('input'):
            inputElement = <input
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ('textarea'):
            inputElement = <textarea
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ('select'):
            inputElement = (
                <select
                    className={inputClasses.join(' ')}
                    value={props.value}
                    onChange={props.changed}>
                    {props.elementConfig.options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.displayValue}
                        </option>
                    ))}
                </select>
            );
            break;
        case ('select_intl'):
            inputElement = (
                <select
                    className={inputClasses.join(' ')}
                    value={props.value}
                    onChange={props.changed}>
                    {props.elementConfig.options.map(option => (
                        <FormattedMessage key={option.id} id={option.id} defaultMessage={option.displayValue} children={
                            (formattedMessage) => <option key={option.value} value={option.value}>{formattedMessage}</option>
                        } />
                    ))}
                </select>
            );
            break;
        case ('radio_intl'):
            inputElement = (
                props.elementConfig.options.map((option) => {
                    return (
                        <span key={option.id}>
                            {option.value === props.value &&
                                <input type='radio' name={props.name} value={option.value} onChange={props.changed} defaultChecked />
                            }
                            {option.value !== props.value &&
                                <input type='radio' name={props.name} value={option.value} onChange={props.changed} />
                            }
                            <FormattedMessage id={option.id} defaultMessage={option.displayValue} />
                        </span>
                    );
                })
            );
            break;
        default:
            inputElement = <input
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
    }

    return (
        <div className={[classes.Input, props.className].join(' ')}>
            {
                (props.label || props.icon) ?
                    <label className={classes.Label}>{props.label ? props.label : (props.icon ? <img alt="" src={props.icon} /> : "")}</label> : ""
            }
            {inputElement}
        </div>
    );

};

export default input;
